module.exports = __webpack_public_path__ + "static/media/brick-brick-wall-city-svgrepo-com.19cc5c25.svg";